import { useCurrentUser } from '../../../contexts/currentUser';
import AdminDashboard from './AdminDashboard';
import OperatorDashboard from './OperatorDashboard';

const AdminMain = () => {
  const { isOperator } = useCurrentUser();
  return isOperator ? <OperatorDashboard /> : <AdminDashboard />;
};

export default AdminMain;
